import React from "react";

import { ReactComponent as PinIcon } from "images/icons/pin.svg"


const AddressEntry = ({
  currentAddress
}: {
  currentAddress: string;
}): React.JSX.Element => {
  return (
    <>
      <div className="text-input has-prefix-icon has-places-autocomplete">
        <label htmlFor="address">Address</label>
        <span>
          <PinIcon className="icon streamline-icon" />
          <input placeholder={currentAddress} data-address-entry-target="field" data-action="keydown->address-entry#keydown input->address-entry#inputChanged" type="search" data-cy="address-input" disabled autoComplete="off" />
        </span>
      </div>
    </>
  );
};

export { AddressEntry }
